import ReactWordcloud, { CallbacksProp, OptionsProp, Word } from 'react-wordcloud';

import styled, { useTheme } from 'styled-components';

import { ReportTopHeader } from 'styles/styled-components/report';
import style from 'styles/styled-components/style';

interface IContentKeyword {
	text: string;
	value: number;
}

const ContentKeyword = ({
	keyword,
	_height = '200px',
}: {
	keyword: IContentKeyword[];
	trend?: number[];
	_height?: string;
}) => {
	const theme = useTheme();

	// 상위 2개의 키워드를 기준으로 색상 결정
	const sortedKeywords = [...keyword].sort((a, b) => b.value - a.value);
	const topKeywords = new Set(sortedKeywords.slice(0, 2).map((item) => item.text));

	const callbacks: CallbacksProp = {
		getWordColor: (word: Word) =>
			topKeywords.has(word.text)
				? theme.colors.uplus.primary50_key
				: theme.colors.gray.gray80_text,
	};

	const options: OptionsProp = {
		colors: ['#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#9467bd', '#8c564b'],
		enableTooltip: false,
		deterministic: true,
		fontSizes: [18, 36],
		fontStyle: 'normal',
		// fontWeight: (word: Word) => (topKeywords.has(word.text) ? 'bold' : '400'),
		padding: 8,
		rotations: 0,
		scale: 'linear',
		spiral: 'archimedean',
		transitionDuration: 1000,
	};

	return (
		<Grid flex="center">
			<Grid _width="90%" _height={_height}>
				<ReactWordcloud callbacks={callbacks} options={options} words={keyword} />
			</Grid>
		</Grid>
	);
};

const { Grid } = style;

export default ContentKeyword;
